import { GetJsDataInfo } from '@bingads-webui-clientcenter/js-data-cc-rest-base';

export function getCcJsData({
  serverContext,
}) {
  return GetJsDataInfo({
    cidFetcher: () => serverContext.CurrentCustomer.Id,
    uidFetcher: () => serverContext.CurrentUser.Id,
    willSupportCors: true,
  }, serverContext.Urls.ClientCenterBaseUrl, ['FeatureAdoptionCoupon']).jsDataCcRest;
}
